import { useAnnouncementFormController } from "./AnnouncementForm.controller";
import { AnnouncementFormProps } from "./AnnouncementForm.types";
import { AnnouncementFormFields } from "./components/AnnouncementFormFields";
import { useEffect } from "react";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { FacultyDTO } from "../../../Api";

const { Option } = Select;

export const AnnouncementForm = (props: AnnouncementFormProps) => {
	const { i18n } = useTranslation();
	const { state, actions, computed } = useAnnouncementFormController(props);

	useEffect(() => {
		actions.setFacultyOptions(
			state.facultiesList
				?.filter((faculty: FacultyDTO) => {
					return (
						state.facultySearch === "" ||
						faculty.facultyNameRo
							?.toLowerCase()
							.includes(state.facultySearch.toLowerCase()) ||
						faculty.facultyNameEn
							?.toLowerCase()
							.includes(state.facultySearch.toLowerCase())
					);
				})
				.filter((f: FacultyDTO) => f.facultyNameRo !== "Altele")
				.map((faculty: FacultyDTO) => (
					<Option key={faculty.id} value={faculty.id}>
						{i18n.language === "en"
							? faculty.facultyNameEn || faculty.facultyNameRo
							: faculty.facultyNameRo}
					</Option>
				)) ?? []
		);
		// actions setters are stable; omit to avoid infinite loop (actions object is new each render)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [i18n.language, state.facultySearch, state.facultiesList]);

	useEffect(() => {
		actions.setDepartmentOptions(
			state.departmentsList
				?.filter((department: any) => {
					return (
						state.departmentSearch === "" ||
						department.departmentNameRo
							?.toLowerCase()
							.includes(state.departmentSearch.toLowerCase()) ||
						department.departmentNameEn
							?.toLowerCase()
							.includes(state.departmentSearch.toLowerCase())
					);
				})
				.map((department: any) => (
					<Option key={department.id} value={department.id}>
						{i18n.language === "en"
							? department.departmentNameEn
							: department.departmentNameRo}
					</Option>
				)) ?? []
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [i18n.language, state.departmentSearch, state.departmentsList]);

	useEffect(() => {
		actions.setStudyProgramOptions(
			state.studyProgramsList
				?.filter((program: any) => {
					return (
						state.studyProgramSearch === "" ||
						program.name
							?.toLowerCase()
							.includes(state.studyProgramSearch.toLowerCase())
					);
				})
				.map((program: any) => (
					<Option key={"p" + program.id} value={program.id}>
						{program.name}
					</Option>
				)) ?? []
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [state.studyProgramSearch, state.studyProgramsList]);

	useEffect(() => {
		actions.setCompanyOptions(
			state.companiesList?.map((c: any) => (
				<Option key={c.id} value={c.id}>
					{c.name ?? c.id}
				</Option>
			)) ?? []
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [state.companiesList]);

	return (
		<AnnouncementFormFields
			form={state.form}
			defaultValues={computed.defaultValues}
			recipientRoleValue={state.recipientRoleValue}
			facultyOptions={state.facultyOptions}
			departmentOptions={state.departmentOptions}
			studyProgramOptions={state.studyProgramOptions}
			companyOptions={state.companyOptions}
			setFacultySearch={actions.setFacultySearch}
			setDepartmentSearch={actions.setDepartmentSearch}
			setStudyProgramSearch={actions.setStudyProgramSearch}
			setCompanySearch={actions.setCompanySearch}
			cancelModalVisibility={state.cancelModalVisibility}
			saveModalVisibility={state.saveModalVisibility}
			setCancelModalVisibility={actions.setCancelModalVisibility}
			setSaveModalVisibility={actions.setSaveModalVisibility}
			handleCancel={actions.handleCancel}
			handleSave={actions.handleSave}
			spinning={state.spinning}
			isLoadingCompanies={computed.isLoadingCompanies}
		/>
	);
};
